import { useState } from "react";
import { ReactComponent as CaretUpIcon } from "../../Assets/caret-up.svg";
import { ReactComponent as ChevronRightIcon } from "../../Assets/angle-right-solid.svg";
import { ReactComponent as PlusIcon } from "../../Assets/plus-solid.svg";
import { ReactComponent as CheckIcon } from "../../Assets/check-solid.svg";
import { useConfigStore } from "../../Stores/Config";
import { useFormStore } from '../../Stores/Form';
import "./FeatureRequestSuggestions.scss";
import CommunicationManager from "../../Helper/CommunicationManager";
import { useRouterStore } from "../../Stores/Router";
import { activateOnKey } from "../../Helper/a11y";

export const suggestionTitle = "We found existing feature requests that might align with your idea. Upvote the ones you like or go ahead and submit your own idea.";

function FeatureRequestSuggestions() {
    const formStore = useFormStore();
    const [openedApp, setOpenedApp] = useState(false);

    return (
        <div className='form-duplicates'>
            {formStore.duplicates?.map((item: any, index: number) => {
                const upvotes = item.upvotesCount ?? 0;
                return (<div key={`duplicate-${index}`} className='form-duplicate' role="button" tabIndex={0} onClick={() => {
                    useFormStore.setState({
                        preserveForm: true,
                    });
                    const routerState = useRouterStore.getState();
                    const currentPage = routerState.currentPage;
                    const currentData = routerState.currentData;
                    if (currentPage === "flow") {
                        useRouterStore.setState({
                            history: [...routerState.history, { page: currentPage, data: currentData }],
                        });
                    }
                    routerState.pushPage("feature-request-details", { id: item.shareToken });
                    setTimeout(() => {
                        setOpenedApp(true);
                    }, 1500);
                }} onKeyDown={activateOnKey(() => {
                    useFormStore.setState({
                        preserveForm: true,
                    });
                    const routerState = useRouterStore.getState();
                    const currentPage = routerState.currentPage;
                    const currentData = routerState.currentData;
                    if (currentPage === "flow") {
                        useRouterStore.setState({
                            history: [...routerState.history, { page: currentPage, data: currentData }],
                        });
                    }
                    routerState.pushPage("feature-request-details", { id: item.shareToken });
                    setTimeout(() => {
                        setOpenedApp(true);
                    }, 1500);
                })}>
                    <div className='form-duplicate__upvotes'>
                        <CaretUpIcon />
                        {upvotes > 99 ? "99+" : upvotes}
                    </div>
                    <div className='form-duplicate__title' title={item.title ?? undefined}>
                        {item.title ?? "--"}
                    </div>
                    <ChevronRightIcon />
                </div>);
            })}
            <div className="duplicate-line" />
            <div key={`duplicate-submitown`} className='form-duplicate' role="button" tabIndex={0} onClick={() => {
                formStore.sendForm(true);
            }} onKeyDown={activateOnKey(() => {
                formStore.sendForm(true);
            })}>
                <div className='form-duplicate__submiticon'>
                    <PlusIcon />
                </div>
                <div className='form-duplicate__title'>
                    {useConfigStore.getState().translateText("kaiSubmitIdea")}
                </div>
                <ChevronRightIcon />
            </div>
            {openedApp && <>
                <div className="duplicate-line" />
                <div key={`duplicate-cancel`} className='form-duplicate' role="button" tabIndex={0} onClick={() => {
                    useRouterStore.getState().setPage("menu");
                    CommunicationManager.getInstance().sendMessage({
                        name: "cleanup-drawings",
                    });
                }} onKeyDown={activateOnKey(() => {
                    useRouterStore.getState().setPage("menu");
                    CommunicationManager.getInstance().sendMessage({
                        name: "cleanup-drawings",
                    });
                })}>
                    <div className='form-duplicate__submiticon'>
                        <CheckIcon />
                    </div>
                    <div className='form-duplicate__title'>
                        {useConfigStore.getState().translateText("kaiSubmitIdeaDone")}
                    </div>
                </div>
            </>}
        </div>);
}

export default FeatureRequestSuggestions;
